import { IAbortControllerFactory } from '../httpClient';
import { HeadersGetter } from '../httpClient/IHttpClientConfig';
import { IUrl } from '../urlService';
import { BrowserFetchServerSentEventsConsumer } from './BrowserFetchServerSentEventsConsumer';
import { IServerSentEventsConsumer } from './IServerSentEventsConsumer';
import type {
    IServerSentEventsConsumerFactory,
} from './IServerSentEventsConsumerFactory';

export class ServerSentEventsConsumerFactory implements IServerSentEventsConsumerFactory {
    constructor(
        private baseUrl: IUrl,
        private abortControllerFactory: IAbortControllerFactory,
        private headersGetter?: HeadersGetter,
    ) {}

    createServerSentEventsConsumer(path: string, timeout?: number): IServerSentEventsConsumer {
        const fullUrl = this.baseUrl.clone().appendPath(path);
        const abortController = this.abortControllerFactory.createAbortController();
        return new BrowserFetchServerSentEventsConsumer(
            fullUrl,
            {
                headersGetter: this.headersGetter,
                streamTimeout: timeout,
            },
            abortController,
        );
    }
}

